
import { api } from '../../../lib/api'

export const UPDATE_NOTIFICATION_REQUEST = 'UPDATE_NOTIFICATION_REQUEST'
export const UPDATE_NOTIFICATION_SUCCESS = 'UPDATE_NOTIFICATION_SUCCESS'
export const UPDATE_NOTIFICATION_FAILED = 'UPDATE_NOTIFICATION_FAILED'

export const TOGGLE_NOTIFICATION_REQUEST = 'TOGGLE_NOTIFICATION_REQUEST'
export const TOGGLE_NOTIFICATION_SUCCESS = 'TOGGLE_NOTIFICATION_SUCCESS'
export const TOGGLE_NOTIFICATION_FAILED = 'TOGGLE_NOTIFICATION_FAILED'

export const updateNotification = function (notificationId, data) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_NOTIFICATION_REQUEST
        })
        api.updateNotification(notificationId, data).then(updateNotificationResponse => {
            dispatch({
                type: UPDATE_NOTIFICATION_SUCCESS,
                payload: updateNotificationResponse
            })
        }).catch(error => {
            dispatch({
                type: UPDATE_NOTIFICATION_FAILED,
                error
            })
        })
    }
}

export const toggleNotification = (notificationId) => {
    return function (dispatch) {
        dispatch({
            type: TOGGLE_NOTIFICATION_REQUEST
        })
        api.toggleNotification(notificationId).then(toggleNotificationResponse => {
            dispatch({
                type: TOGGLE_NOTIFICATION_SUCCESS,
                payload: toggleNotificationResponse,
                notificationId
            })
        }).catch(error => {
            dispatch({
                type: TOGGLE_NOTIFICATION_FAILED,
                error
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/notification/update-notification.js